import { Flex, Text } from '@wegroup/design-system';
import React from 'react';
import textStyles from '../../../design-system/src/theme/foundations/textStyles';
import { blink } from '../utils/cssAnimationsUtils';

interface AnimationDotProps {
  delay?: string | number;
  textStyle?: keyof typeof textStyles;
}

const AnimatedDot: React.FC<React.PropsWithChildren<AnimationDotProps>> = ({
  delay = 0,
  textStyle,
}) => (
  <Text
    animation={`${blink} infinite 1.5s linear`}
    sx={{ animationDelay: delay }}
    textStyle={textStyle}
  >
    .
  </Text>
);

interface Props {
  color?: string;
  textStyle?: keyof typeof textStyles;
}

const DotLoaderWithText: React.FC<React.PropsWithChildren<Props>> = ({
  color = 'white',
  textStyle = 'normalBody',
  children,
}) => {
  return (
    <Flex textAlign="center" color={color}>
      <Text textStyle={textStyle} color={color}>
        {children}
      </Text>
      <AnimatedDot textStyle={textStyle} />
      <AnimatedDot textStyle={textStyle} delay="0.2s" />
      <AnimatedDot textStyle={textStyle} delay="0.4s" />
    </Flex>
  );
};

export default DotLoaderWithText;
